const KEY = 'goaltree.search.recent'
const MAX = 10

// Ids of goals/tasks the user recently opened, newest first (this device only).
export function getRecentIds(): string[] {
  try {
    const ids = JSON.parse(localStorage.getItem(KEY) ?? '[]')
    return Array.isArray(ids) ? ids.filter((x): x is string => typeof x === 'string') : []
  } catch {
    return []
  }
}

export function pushRecent(id: string) {
  try {
    const next = [id, ...getRecentIds().filter((x) => x !== id)].slice(0, MAX)
    localStorage.setItem(KEY, JSON.stringify(next))
  } catch {}
}
